import { Injectable } from '@angular/core';

import { PageNavigationService } from './page-navigation.service';

@Injectable()
export class PopupService {

    popupConfirmation: boolean = false;
    popupChangePassword: boolean = false;
    popupChangeSecurityQuestion: boolean = false;
    popupViewPlantmap: boolean = false;
    popupChangeAppointment: boolean = false;
    popupRestrictedConfirmation: boolean = false;
    popupResetPasword: boolean = false;
    popUpOptions: any;

    // For tutorial

    currentPage: string = '';

    constructor(
        private _pageNavigationService: PageNavigationService
    ) {
        
    }

    /*openConfirmationPopup(options: any) {
        this.popUpOptions = options;
        this.confirmationPopup = true;
    }

    closeConfirmationPopup() {
        this.confirmationPopup = false;
    }

    getConfirmationFlag() {
        return this.confirmationPopup;
    }

    setConfirmationFlag(flag: boolean) {
        this.confirmationPopup = flag;
    }*/

    openPopup(type: string, options: any) {
        this.popUpOptions = options;
        if(type === 'confirmation'){
            this.popupConfirmation = true;
        }else if(type === 'change-password'){
            this.popupChangePassword = true;
        }else if(type === 'change-security-question'){
            this.popupChangeSecurityQuestion = true;
        }else if(type === 'view-plantmap'){
            this.popupViewPlantmap = true;
        }else if(type === 'change-appointment'){
            this.popupChangeAppointment = true;
        }else if(type === 'restricted-confirmation'){
            this.popupRestrictedConfirmation = true;
        }else if(type === 'reset-user'){
            this.popupResetPasword = true;
        }
    }

    closePopup() {
        this.popupChangePassword = false;
        this.popupChangeSecurityQuestion = false;
        this.popupConfirmation = false;
        this.popupViewPlantmap = false;
        this.popupChangeAppointment = false;
        this.popupRestrictedConfirmation = false;
        this.popupResetPasword = false;
    }

    closeConfirmationPopup() {
        this.popupConfirmation = false;
    }

    getConfirmationFlag() {
        return this.popupConfirmation;
    }

    getChangePasswordFlag() {
        return this.popupChangePassword;
    }

    getChangeSecurityQuestionFlag() {
        return this.popupChangeSecurityQuestion;
    }

    getViewPlantmapFlag() {
        return this.popupViewPlantmap;
    }

    getChangeAppointmentFlag() {
        return this.popupChangeAppointment;
    }

    getRestrictedConfirmationFlag() {
        return this.popupRestrictedConfirmation;
    }

    getResetPasswordFlag() {
        return this.popupResetPasword;
    }

    /*setConfirmationFlag(flag: boolean) {
        this.popup = flag;
    }*/

    openGeneralConfirmationPopup(pTitle: string, pMessage: string, pSLMessage: string, isCheckedImage: boolean, isErrorImage: boolean){
        this.openPopup( 'confirmation', {
            title: pTitle,
            message: pMessage,
            secondLineMessage: pSLMessage,
            isCheckedImage: isCheckedImage,
            isErrorImage: isErrorImage,
            buttons: {
                CANCEL: {
                    text: 'Close',
                    function: () => {
                        this.closePopup();
                    }
                }
            }
        });
    }

    openLinkConfirmationPopup(pTitle: string, pMessage: string, pSLMessage: string, isCheckedImage: boolean, isErrorImage: boolean, pButtonName: string, pNav: string){
        this.openPopup( 'confirmation', {
            title: pTitle,
            message: pMessage,
            secondLineMessage: pSLMessage,
            isCheckedImage: isCheckedImage,
            isErrorImage: isErrorImage,
            buttons: {
                CANCEL: {
                    text: pButtonName,
                    function: () => {
                        this._pageNavigationService.navigate([pNav]);
                        this.closePopup();
                    }
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/services/pop-up.service.ts